<template>
  <detail-layout v-if="true">
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="mb-4">
              <div class="mandatory">
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('webhooks.details.estadowebhook') }}</label>
                  <el-switch 
                    class="switch-text break-normal both-switch" 
                    v-model="form.activo" 
                    :disabled="false"
                    :active-text="$t('app.active')" 
                    />
                </div>
                <div class="lg:mb-4" v-if="role === 3 && parseInt($route.params.idWebHook) !== -1">
                  <el-form-item prop="clienteId" class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('clients.entity_name') }}</label>
                    <base-el-select class="w-full" :options="[form.client]" v-model="form.client" filterable clearable disabled />
                  </el-form-item>
                </div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.namewebhook') }}</label>
                <el-form-item prop="namewebhook">
                    <el-input class="w-full" v-model="form.namewebhook" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.tipowebhooknnotificacion') }}</label>
                <el-form-item prop="tipowebhooknnotificacion">
                    <base-el-select class="w-full" v-model="form.tipowebhooknnotificacion" :options="tiposWebhook" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.authenticationtype') }}</label>
                <el-form-item prop="authenticationtype">
                  <base-el-select class="w-full" v-model="form.authenticationtype" :options="tiposAutenticacion" :disabled="isGeneralLoading || !isZerocoma" clearable/>
                </el-form-item>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.webhookurl') }}</label>
                <el-form-item prop="webhookurl">
                    <el-input class="w-full" v-model="form.webhookurl" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <el-form-item v-if="isRequiredUserAndPassword" prop="authenticationurl">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.authenticationurl') }}</label>
                    <el-input class="w-full" v-model="form.AuthenticationURL" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <el-form-item v-if="isRequiredUserAndPassword" prop="authenticationuser">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.authenticationuser') }}</label>
                    <el-input class="w-full" v-model="form.authenticationuser" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <el-form-item v-if="isRequiredPasswordForToken && isZerocoma" prop="authenticationpassword">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ isRequiredUserAndPassword? $t('webhooks.details.authenticationpassword'): $t('webhooks.details.authenticationtoken') }}</label>
                    <el-input class="w-full" v-model="form.authenticationpassword" :disabled="isRoleUserOrConsulta" clearable />
                </el-form-item>
                <el-form-item prop="subscription">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('webhooks.details.subscription') }}</label>
                    <base-el-select class="w-full" v-model="form.subscription" :options="eventsAviable" :disabled="isRoleUserOrConsulta" clearable multiple/>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitFormAction"
                :loading="isGeneralLoading" :disabled="isRoleUserOrConsulta" />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
// import { getClient } from '@/services/clients/getClient'
import { getWebhooksDetails } from '@/services/configurations/webhooks/getWebhooksDetails'
import { getWebhookEvents } from '@/services/configurations/webhooks/getWebhooksEvents'
import { addWebhookSubscriber } from '@/services/configurations/webhooks/addWebhookSubscriber'
import { modifyWebhookSubscriber } from '@/services/configurations/webhooks/modifyWebhoksSubscriber'
import { i18n } from '@/i18n'
export default {
  components: {
    DetailLayout
  },
  data () {
    return {
      header: {
        title: i18n.t('webhooks.details.header'),
        icon: 'config',
        url: 'configurations/clients/webhooks',
        breadcrumb: [],
        params: this.$route.params
      },
      form: {
        client: '',
        namewebhook: '',
        webhookurl: '',
        authenticationtype: '',
        AuthenticationURL: '',
        authenticationuser: '',
        authenticationpassword: '',
        tipowebhooknnotificacion: '',
        activo: false,
        subscription: []
      },
      rules: {
        namewebhook: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        webhookurl: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        authenticationtype: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipowebhooknnotificacion: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        subscription: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        authenticationpassword: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        authenticationuser: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        authenticationurl: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
      },
      eventsAviable: [],
      tipoAutenticacionAntiguo: ''
    }
  },
  watch: {
    'form.tipowebhooknnotificacion': function (value, oldValue) {
      if (value !== oldValue) {
        if (value && !this.isZerocoma) this.form.authenticationtype = 'None'
      }
    },
  },
  mounted () {
  },
  computed: {
    isRequiredUserAndPassword: function () {
      if (this.form.authenticationtype === 'UserPassword') {
        return true
      }
      return false
    },
    isRequiredPasswordForToken: function () {
      if ((this.form.authenticationtype === 'StaticToken' || this.form.authenticationtype === 'UserPassword')) {
        return true
      }
      return false
    },
    isZerocoma: function () {
      return this.form.tipowebhooknnotificacion === 'Zerocoma'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id ? this.$route.params.id : this.$store.getters['auth/user'].idCliente
    },
    isFromClient: function () {
      return !!this.$route.params.id
    },
    tiposWebhook: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_NOTIFICATION']
    },
    tiposAutenticacion: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_AUTH']
    },
    tiposEventos: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_EVENT']
    },
  },

  methods: { 
    goBack: function () {
      this.$router.push({ name: this.header.url, params: { id: this.id } })
    },
    submitFormAction: function () {
      this.submitForm('ruleForm')
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              IdWebHookSubscriber: parseInt(this.$route.params.idWebHook),
              IdCliente: parseInt(this.$route.params.id),
              Name: this.form.namewebhook,
              WebHookURL: this.form.webhookurl,
              NotificationType: this.form.tipowebhooknnotificacion,
              AuthenticationType: this.form.authenticationtype,
              // AuthenticationType: 'None',
              AuthenticationURL: this.form.AuthenticationURL,
              AuthenticationUser: this.form.authenticationuser,
              AuthenticationPassword: this.form.authenticationpassword,
              Subscriptions: this.form.subscription,
              Active: this.form.activo
            }
            var response = null
            if (data.IdWebHookSubscriber === -1) {
              response = await addWebhookSubscriber(data)
            } else {
              response = await modifyWebhookSubscriber(data)
            }
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              if (data.IdWebHookSubscriber === -1) { 
                this.cleanWebhokForm()
              }
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },

    setWebhokDetails: function (webhookDetails) {
      this.form.namewebhook = webhookDetails?.Name ?? ''
      this.form.webhookurl = webhookDetails?.WebHookURL ?? ''
      this.form.authenticationtype = webhookDetails?.AuthenticationType ?? ''
      // this.form.authenticationtype = 'None'
      this.form.authenticationuser = webhookDetails?.AuthenticationUser ?? ''
      this.form.authenticationpassword = webhookDetails?.AuthenticationPassword ?? ''
      this.form.tipowebhooknnotificacion = webhookDetails?.NotificationType ?? ''
      this.form.AuthenticationURL = webhookDetails?.AuthenticationURL ?? ''
      this.form.activo = !!webhookDetails?.Active
      this.form.subscription = webhookDetails?.Subscriptions ?? []
      this.form.client = webhookDetails?.Cliente ?? ''
      this.tipoAutenticacionAntiguo = webhookDetails.AuthenticationType ?? ''
    },

    cleanWebhokForm: function () {
      this.form = {
        namewebhook: '',
        webhookurl: '',
        authenticationtype: '',
        // authenticationtype: 'None',
        AuthenticationURL: '',
        authenticationuser: '',
        authenticationpassword: '',
        tipowebhooknnotificacion: '',
        activo: true,
        subscription: []
      }
    },

    getWebhookEventsMethod: async function (params) {
      return getWebhookEvents(params)
    },

    getWebhookEventsObjectAviable: function (webhookEvents) {
      var eventName = []
      webhookEvents.forEach(x => {
        eventName.push(this.tiposEventos.filter(y => y.value === x.IdEventType)[0] || { value: x.IdEventType })
      })
      return eventName
    },
    getWebhookEventsObjectSelected: function (webhookEvents) {
      var eventName = []
      webhookEvents.forEach(x => {
        eventName.push(this.form.subscription.filter(y => y === x.IdEventType)[0])
      })
      return eventName
    }
  },
  created: async function () {
    var params = { idCliente: this.id, idSubscriber: this.$route.params.idWebHook }
    var webhooksDetailsResponse = null
    var webhookName = null
    if (parseInt(this.$route.params.idWebHook) !== -1) {
      webhooksDetailsResponse = await getWebhooksDetails(params)
      webhookName = webhooksDetailsResponse?.Respuesta?.Name
      this.setWebhokDetails(webhooksDetailsResponse?.Respuesta)
    } else {
      webhookName = i18n.t('webhooks.new_webhook')
    }
    const webhookEvents = await this.getWebhookEventsMethod({ idCliente: this.id })
    this.eventsAviable = this.getWebhookEventsObjectAviable(webhookEvents?.Respuesta)

    this.header.url = this.isFromClient ? 'configurations/clients/webhooks' : 'configurations/webhooks'
    const breadcrumbs = []
    breadcrumbs.push({ path: this.role === 3 ? 'configurationssa' : 'configurations', name: i18n.t('configurations.header') })
    if (this.isFromClient) {
      breadcrumbs.push({ path: 'configurations/clients', name: i18n.t('clients.header') })
      breadcrumbs.push({ path: 'configurations/clients/details', name: this.form.client })
      this.$store.commit('app/setheaderBreadCrumb', this.form.client)
    }
    breadcrumbs.push({ path: this.isFromClient ? 'configurations/clients/webhooks' : 'configurations/webhooks', name: i18n.t('webhooks.header') })
    
    breadcrumbs.push({ path: '', name: webhookName })
    this.$store.commit('app/setstateBreadCrumb', { id: 0, Nombre: webhookName })
    this.header.breadcrumb = breadcrumbs
  }
}
</script>

<style>

</style>
